module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("Авторизация в Приват24 для бизнеса")]), _vm._v(" "), _c('privat-auth-form', {
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2480a5bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PrivatAuth.vue
// module id = 603
// module chunks = 0